import { DateTime } from "luxon";
import CircularGraphWithIcon from "../Graph/CircularGraph";

export const AssessmentContainer = (props: any) => {
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  const { count, type, maxscore, averageScore, uniqueUsers, monthValue } = props;
  function getCategory(score: number, maxScore: number) {
    const percentage = (score / maxScore) * 100;
    if (percentage < 30) {
      return "Low";
    } else if (percentage < 70) {
      return "Mid";
    } else {
      return "High";
    }
  }

  function getMonthName(dateString: string) {
    const date = DateTime.fromISO(dateString);
    return date.toFormat("MMMM");
  }

  return (
    <div>
      <div
        style={{
          flex: 1,
          backgroundColor: "#fff",
          marginRight: "20px",
          borderRadius: "8px",
        }}
      >
        <div style={{ padding: " 25px 20px 5px 20px" }}>
          {`The Manoshala ${type.charAt(0).toUpperCase() + type.slice(1)} Test`}
        </div>
        <div style={{ fontSize: "12px", color: "#ccbeb6", padding: "0 20px" }}>
          {monthValue ? getMonthName(monthValue)+ " Average" :"All time"}
        </div>
        <div style={{ padding: "20px 0" }}>
          <CircularGraphWithIcon average={Math.round(averageScore)} total={maxscore} />
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "24px",
            fontWeight: "bold",
            paddingBottom: "10px",
          }}
        >
          {Math.round(averageScore)}
        </div>
        <div
          style={{
            textAlign: "center",
            fontSize: "16px",
            backgroundColor: "#fff7d0",
            color: "#b0751b",
            width: "100px",
            margin: "auto",
            borderRadius: "20px",
            padding: "8px",
          }}
        >
          {getCategory(averageScore, maxscore)}
        </div>
        <div
          style={{
            textAlign: "center",
            padding: "25px 0 20px 0",
            fontSize: "14px",
            color: "#e7765f",
          }}
        >
          {`${uniqueUsers} ${access_code? "employees":"users"} took this assessment`}
        </div>
      </div>
    </div>
  );
};
